<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type effect="light" expand>
      <router-link class="navbar-brand d-none d-lg-block" to="/">
        <img src="/img/brand/logo.svg" alt="logo" style="height: 70px;"/>
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <router-link class="col-6 collapse-brand" to="/">
          <img src="/img/brand/logo.svg" alt="logo"  />
        </router-link>

        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav ml-lg-auto">
        <li class="nav-item">
          <router-link class="nav-link nav-link-icon" to="/">Inicio</router-link>
        </li>
        <li class="nav-item" v-if="!signedIn">
          <router-link class="nav-link nav-link-icon" to="/registro">Activación</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-icon" to="/beneficios">Beneficios</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-icon" to="/contacto">Contacto</router-link>
        </li>
        <li class="nav-item" v-if="!signedIn">
          <a class="nav-link nav-link-icon" href="https://panel-masvivos.medellinjoven.com/">Aliados</a>
        </li>
        <base-dropdown tag="li" :title="user" v-if="signedIn">
          <router-link class="dropdown-item" to="/actualizar-perfil">Actualizar perfil</router-link>
          <router-link class="dropdown-item" to="/historial-redenciones">Historial de redenciones</router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="logout" style="cursor: pointer">Salir</a>
        </base-dropdown>
        <li class="nav-item" v-if="!signedIn">
          <router-link class="nav-link nav-link-icon" to="/FAQ">FAQ</router-link>
        </li>
        <li class="nav-item" v-if="!signedIn">
          <router-link class="nav-link nav-link-icon" to="/login">Iniciar Sesión</router-link>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

import { Auth } from "aws-amplify";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  data() {
    return {
    }
  },
  methods: {
    logout() {
      Auth.signOut()
        .then(data => this.$router.push('/login'))
        .catch(err => alert('Ocurrió un error intentando cerrar la sesión'));
      this.$store.commit('setSignOut');

    },
  },
  computed:{
    signedIn(){
      return this.$store.state.signedIn;
    },
    user(){
      return this.$store.state.user.attributes.name;
    }
  }
};
</script>
<style>
</style>
